import fittingsData from '../fittingsData';

const DN_TO_PIPE_DIAMETER = {
  32: 42.4,
  40: 48.3,
  50: 60.3,
  65: 76.1,
  80: 88.9,
  100: 114.3,
  125: 139.7,
  150: 168.3,
  200: 219.1,
  250: 273,
  300: 323.9,
  350: 355.6,
};

const isFittingCompatibleWithMainPipe = (fittingId, mainPipeDiameter) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // ========== Ограничения для гребенки 42.4мм ==========
  if (mainPipeDiameter === 42.4) {
    // Ниппели: запрещены больше 3/4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1/2
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_1_1.4' || fittingId === 'Nak_Gaika_1_1.2' || fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_1_1.4' || fittingId === 'Shaib_Nar_Rezba_1_1.2' || fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для гребенки 48.3мм ==========
  if (mainPipeDiameter === 48.3) {
    // Ниппели: запрещены больше 3/4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 3/4
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_1_1.4' || fittingId === 'Nak_Gaika_1_1.2' || fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_1_1.4' || fittingId === 'Shaib_Nar_Rezba_1_1.2' || fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для гребенки 60.3мм ==========
  if (mainPipeDiameter === 60.3) {
    // Ниппели: запрещены больше 1
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: только Ду25 (труба 33,7 мм — как ниппель 1")
    if (category === 'Фланцы') {
      return fittingId.startsWith('Flanec_25_');
    }

    // Накидные гайки: запрещены больше 1 1/2"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1 1/2"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для гребенки 76.1мм ==========
  if (mainPipeDiameter === 76.1) {
    // Ниппели: запрещены больше 1 1/2
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2"
      // Запрещены: 2", 2 1/2", 3", 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/4
    if (category === 'Муфты') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4"
      // Запрещены: 1 1/2", 2"
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду40
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду50, Ду65, Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 88.9мм ==========
  if (mainPipeDiameter === 88.9) {
    // Ниппели: запрещены больше 2
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2", 2"
      // Запрещены: 2 1/2", 3", 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/2
    if (category === 'Муфты') {
      // Разрешены: 1/4", 3/8", 1/2", 1", 1 1/4", 1 1/2"
      // Запрещены: 2"
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду65, Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 101.6мм ==========
  if (mainPipeDiameter === 101.6) {
    // Ниппели: запрещены больше 2
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2", 2"
      // Запрещены: 2 1/2", 3", 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду65, Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 114.3мм ==========
  if (mainPipeDiameter === 114.3) {
    // Ниппели: запрещены больше 2 1/2
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2", 2", 2 1/2"
      // Запрещены: 3", 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду65
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 129мм ==========
  if (mainPipeDiameter === 129) {
    // Ниппели: запрещены больше 3
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2", 2", 2 1/2", 3" 
      // Запрещены: 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду80
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65, Ду80 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 139.7мм ==========
  if (mainPipeDiameter === 139.7) {
    // Ниппели: запрещены больше 3
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2", 2", 2 1/2", 3" 
      // Запрещены: 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду80
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65, Ду80 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 159мм ==========
  if (mainPipeDiameter === 159) {
    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65, Ду80, Ду100 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 168.3мм ==========
  if (mainPipeDiameter === 168.3) {
    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65, Ду80, Ду100 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 219.1мм ==========
  if (mainPipeDiameter === 219.1) {
    // Фланцы: запрещены больше Ду125
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 273мм ==========
  if (mainPipeDiameter === 273) {
    // Фланцы: запрещены больше Ду150
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125')|| fittingId.startsWith('Flanec_150')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 323.9мм ==========
  if (mainPipeDiameter === 323.9) {
    // Фланцы: запрещены больше Ду200
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 355.6мм ==========
  if (mainPipeDiameter === 355.6) {
    // Фланцы: запрещены больше Ду200
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 406.4мм ==========
  if (mainPipeDiameter === 406.4) {
    // Фланцы: запрещены больше Ду250
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200') || fittingId.startsWith('Flanec_250')) {
        return true;
      }
      return false;
    }
  }

  return true;
};

const isFittingCompatibleWithSquareProfile = (fittingId, profile) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // ========== Ограничения для профиля 40x40 ==========
  if (profile === '40x40') {
    // Ниппели: запрещены больше 3/4"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1/2"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1"
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1'];
      return allowedNakGaikas.includes(fittingId);
    }

    // Шайбы с наружной резьбой: запрещены больше 1"
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1'];
      return allowedShaibas.includes(fittingId);
    }
  }

  // ========== Ограничения для профиля 50x50 ==========
  if (profile === '50x50') {
    // Ниппели: запрещены больше 1"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 3/4"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1 1/2"
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1', 'Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2'];
      return allowedNakGaikas.includes(fittingId);
    }

    // Шайбы с наружной резьбой: запрещены больше 1 1/2"
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1', 'Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2'];
      return allowedShaibas.includes(fittingId);
    }
  }

  // ========== Ограничения для профиля 60x60 ==========
  if (profile === '60x60') {
    // Ниппели: запрещены больше 1 1/4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: как ниппели — не больше 1 1/4" (тот же ряд резьбы, что и у ниппеля)
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду32
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 80x80 ==========
  if (profile === '80x80') {
    // Ниппели: запрещены больше 2
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2' ];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/2
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду65, Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 100x100 ==========
  if (profile === '100x100') {
    // Ниппели: запрещены больше 2 1/2"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2' ];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: разрешены любые
    if (category === 'Муфты') {
      return true;
    }

    // Фланцы: запрещены больше Ду65
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду80, Ду100, Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 150x150 ==========
  if (profile === '150x150') {
    // Ниппели: разрешены любые
    if (category === 'Ниппели') {
      return true;
    }

    // Муфты: разрешены любые
    if (category === 'Муфты') {
      return true;
    }

    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40, Ду50, Ду65, Ду80, Ду100  (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду125, Ду150
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  return true;
};

const isEndFittingCompatibleWithMainPipe = (fittingId, mainPipeDiameter) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // Ниппели: не могут быть больше диаметра гребенки
  if (category === 'Ниппели') {
    const nippelDiameter = fittingData.diameter;
    if (nippelDiameter > mainPipeDiameter) {
      return false;
    }
  }

  // Фланцы: не могут быть больше диаметра гребенки
  if (category === 'Фланцы') {
    // Извлекаем Ду из ключа фланца
    const dnMatch = fittingId.match(/Flanec_(\d+)/);
    if (dnMatch) {
      const dn = parseInt(dnMatch[1]);
      const flangePipeDiameter = DN_TO_PIPE_DIAMETER[dn];
      if (flangePipeDiameter && flangePipeDiameter > mainPipeDiameter) {
        return false;
      }
    }
  }

  // Муфты: специальные ограничения
  if (category === 'Муфты') {
    if (mainPipeDiameter === 42.4) {
      // Для 42.4: не больше 1 1/4"
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    } else if (mainPipeDiameter === 48.3) {
      // Для 48.3: не больше 1 1/2"
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }
    // Для остальных диаметров: без ограничений
  }

  return true;
};

const isEndFittingCompatibleWithSquareProfile = (fittingId, profile) => {
  // Используем ту же логику, что и для контурных фитингов
  return isFittingCompatibleWithSquareProfile(fittingId, profile);
};
export {
  isFittingCompatibleWithMainPipe,
  isFittingCompatibleWithSquareProfile,
  isEndFittingCompatibleWithMainPipe,
  isEndFittingCompatibleWithSquareProfile,
};
